module.exports = __webpack_public_path__ + "static/app-21255e8143c164a75116eaabf309bbaf.png";